module.exports = __webpack_public_path__ + "img/truck-vector.6efe3fe5.png";